import React from "react";
import {OrbitComponent} from "../../base-components/orbit-component/orbit-component";
import {LoyaltyBarWrapperComponent} from "../../loyalty-bar/loyalty-bar-wrapper.component";

export class LoyaltyBarSideMenuLink extends OrbitComponent {

    render() {
        return (
            <LoyaltyBarWrapperComponent />
        );
    }

}
